import { useEffect, useState } from "react";
import { Download } from "lucide-react";

export default function PWAInstallButton({ className = "", testid = "pwa-install-btn" }) {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    const installedHandler = () => setInstalled(true);
    window.addEventListener("appinstalled", installedHandler);

    // Already installed (standalone)?
    if (window.matchMedia?.("(display-mode: standalone)").matches) {
      setInstalled(true);
    }

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.removeEventListener("appinstalled", installedHandler);
    };
  }, []);

  if (installed) {
    return (
      <div className={`text-sm text-[var(--vidoc-success)] ${className}`}>
        ✓ Application installée
      </div>
    );
  }

  if (!prompt) {
    return (
      <div className={`text-sm text-[var(--vidoc-text-secondary)] ${className}`}>
        Sur iPhone : utilisez « Partager » → « Sur l'écran d'accueil ».
        <br />
        Sur Android : un bouton apparaîtra automatiquement.
      </div>
    );
  }

  const handleInstall = async () => {
    try {
      prompt.prompt();
      await prompt.userChoice;
    } catch (e) {
      console.warn("[PWAInstallButton] install prompt failed", e);
    } finally {
      setPrompt(null);
    }
  };

  return (
    <button
      data-testid={testid}
      type="button"
      onClick={handleInstall}
      className={`flex items-center gap-2 px-4 py-3 rounded-xl bg-[var(--vidoc-primary)] text-white font-medium touch-target hover:bg-[var(--vidoc-primary-dark)] ${className}`}
    >
      <Download className="w-5 h-5" />
      Installer l'application
    </button>
  );
}
